"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSToast = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = tslib_1.__importStar(require("react"));
/** @jsxRuntime classic */
/** @jsx jsx */
var react_2 = require("@emotion/react");
var BDSToast_style_1 = require("./BDSToast.style");
var BDSFontIcon_1 = require("../../Basic/BDSFontIcon/BDSFontIcon");
var BDSToast = function (props) {
    var type = props.type, text = props.text;
    var _a = react_1.useState(true), toast = _a[0], setToast = _a[1];
    var handleToast = react_1.useCallback(function () {
        setTimeout(function () {
            setToast(false);
        }, 4000);
    }, []);
    react_1.useEffect(function () {
        handleToast();
    }, []);
    var handleToastStyle = react_1.useCallback(function (Type) {
        switch (Type) {
            case 'success':
                return {
                    name: 'ic-check-alt',
                    color: '#27c28a',
                    backGroundColor: '#bbf3de',
                };
            case 'warning':
                return {
                    name: 'ic-warning',
                    color: '#ffab00',
                    backGroundColor: '#f2e2c1',
                };
            case 'error':
                return {
                    name: 'ic-delete-alt',
                    color: '#e65c5c',
                    backGroundColor: '#f8dbd4',
                };
            case 'info':
                return {
                    name: 'ic-info',
                    color: '#3399FF',
                    backGroundColor: '#CAE4FF;',
                };
            default:
                return {
                    name: 'ic-delete-alt',
                    color: '#e65c5c',
                    backGroundColor: '#f8dbd4',
                };
        }
    }, []);
    var toastColor = react_2.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    background-color: ", ";\n    border: 1px solid ", ";\n  "], ["\n    background-color: ", ";\n    border: 1px solid ", ";\n  "])), handleToastStyle(type).backGroundColor, handleToastStyle(type).color);
    return (jsx_runtime_1.jsx(react_1.default.Fragment, { children: toast && (jsx_runtime_1.jsxs("div", tslib_1.__assign({ css: [BDSToast_style_1.baseCss, toastColor, BDSToast_style_1.toastUp] }, { children: [jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: handleToastStyle(type).name, color: handleToastStyle(type).color, size: "20px" }, void 0),
                jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "toast-text" }, { children: text }), void 0)] }), void 0)) }, void 0));
};
exports.BDSToast = BDSToast;
var templateObject_1;
